export class Status {
    public static UNPUBLISHED = 'unpublished';
    public static POSTED = 'posted';
    public static SUBMITTED = 'submitted';
    public static ACCEPTED = 'accepted';
    public static ONLINE_PUBLICATION = 'epub';
    public static PUBLISHED = 'published';
}
